import { render } from "./ActivateRounds.vue?vue&type=template&id=034990d8&scoped=true"
import script from "./ActivateRounds.vue?vue&type=script&lang=js"
export * from "./ActivateRounds.vue?vue&type=script&lang=js"

import "./ActivateRounds.vue?vue&type=style&index=0&id=034990d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034990d8"]])

export default __exports__